import { render, staticRenderFns } from "./pagination-template.vue?vue&type=template&id=4c651913&lang=pug&"
import script from "./pagination-template.vue?vue&type=script&lang=js&"
export * from "./pagination-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports